import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["content", "accessibilityLabel", "position"];
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef } from 'react';
import classnames from 'classnames';
import Utility from "../../Utility/Utility";
import { Text } from "../../Text/Text/Text";
import { TextPrice } from "../TextPrice/TextPrice";
import { PriceBreakdown } from "../PriceBreakdown/PriceBreakdown";
import { AddonToggle } from "../AddonToggle/AddonToggle";
import { RadioInput } from "../../Input/RadioInput/RadioInput";
import { IconButton } from "../../Button/IconButton/IconButton";
import { Popup } from "../../Popup/Popup/Popup";
import Colors from "../../Color/Colors";
import { MatchHeightElement } from "../../Utility/MatchHeight/MatchHeightElement";
import styles from "./ChangeDurationItem.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ChangeDurationItem = function ChangeDurationItem(_ref) {
  var cta = _ref.cta,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$valueSelected = _ref.valueSelected,
    valueSelected = _ref$valueSelected === void 0 ? '' : _ref$valueSelected,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$labelTypog = _ref.labelTypog,
    labelTypog = _ref$labelTypog === void 0 ? 'headline5' : _ref$labelTypog,
    _ref$flag = _ref.flag,
    flag = _ref$flag === void 0 ? '' : _ref$flag,
    _ref$textPrice = _ref.textPrice,
    textPrice = _ref$textPrice === void 0 ? [] : _ref$textPrice,
    priceBreakdown = _ref.priceBreakdown,
    tooltip = _ref.tooltip,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    version = _ref.version,
    _ref$wrapperClass = _ref.wrapperClass,
    wrapperClass = _ref$wrapperClass === void 0 ? '' : _ref$wrapperClass,
    _ref$mobileCarousel = _ref.mobileCarousel,
    mobileCarousel = _ref$mobileCarousel === void 0 ? false : _ref$mobileCarousel,
    addonToggle = _ref.addonToggle,
    simplifiedCards = _ref.simplifiedCards,
    promoCopy = _ref.promoCopy;
  var popupComponent = useRef(null);
  var togglePopup = function togglePopup() {
    if (popupComponent) {
      var _popupComponent$curre;
      popupComponent === null || popupComponent === void 0 ? void 0 : (_popupComponent$curre = popupComponent.current) === null || _popupComponent$curre === void 0 ? void 0 : _popupComponent$curre.togglePopup();
    }
  };
  var onItemChange = function onItemChange(option) {
    onChange(option);
  };
  var renderTooltip = function renderTooltip() {
    var _ref2 = tooltip || {},
      content = _ref2.content,
      accessibilityLabel = _ref2.accessibilityLabel,
      position = _ref2.position,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    if (simplifiedCards) {
      return tooltip && content && /*#__PURE__*/_jsx(Popup, {
        ref: popupComponent,
        handle: /*#__PURE__*/_jsx(IconButton, _objectSpread({
          "aria-label": accessibilityLabel,
          className: styles.tooltipV6,
          icon: "info",
          fill: '#93929E',
          size: "16px",
          onClick: togglePopup
        }, otherProps)),
        children: /*#__PURE__*/_jsx("div", {
          className: styles.tooltipContent,
          children: /*#__PURE__*/_jsx(Text, {
            richText: true,
            typog: "bodycopy",
            children: content
          })
        })
      });
    } else {
      return tooltip && content && /*#__PURE__*/_jsx(Popup, {
        ref: popupComponent,
        handle: /*#__PURE__*/_jsx(IconButton, _objectSpread({
          "aria-label": accessibilityLabel,
          className: styles.tooltip,
          icon: "info",
          fill: Colors.colorWW740,
          size: "16px",
          onClick: togglePopup
        }, otherProps)),
        children: /*#__PURE__*/_jsx("div", {
          className: styles.tooltipContent,
          children: /*#__PURE__*/_jsx(Text, {
            richText: true,
            typog: "bodycopy",
            children: content
          })
        })
      });
    }
  };
  var restructurePriceText = function restructurePriceText(textPrice) {
    var textPriceBlocks = [];
    var currentBlock = null;
    var _iterator = _createForOfIteratorHelper(textPrice),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (item.subLabel) {
          if (currentBlock) {
            textPriceBlocks.push(currentBlock);
          }
          currentBlock = {
            subLabel: item.subLabel,
            textPrice: [item]
          };
        } else if (currentBlock) {
          currentBlock.textPrice.push(item);
        } else {
          if (!textPriceBlocks.length) {
            currentBlock = {
              subLabel: '',
              textPrice: [item]
            };
          } else {
            textPriceBlocks[0].textPrice.push(item);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (currentBlock) {
      textPriceBlocks.push(currentBlock);
    }
    return textPriceBlocks;
  };
  var renderDescription = function renderDescription() {
    if (simplifiedCards) {
      var textPriceBlocks = restructurePriceText(textPrice);
      var hasStrikethrough = textPrice.some(function (item) {
        return item.strikethrough;
      });
      var hasMultipleBlocks = textPriceBlocks.length > 1;
      return /*#__PURE__*/_jsxs(React.Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: classnames(styles.textPriceBlocksWrapperV6, {
            [styles.withStrikethrough]: hasStrikethrough,
            [styles.multipleBlocks]: hasMultipleBlocks
          }),
          children: textPriceBlocks === null || textPriceBlocks === void 0 ? void 0 : textPriceBlocks.map(function (block, blockIdx) {
            var textPrices = block.textPrice;
            var hasPlus = blockIdx < textPriceBlocks.length - 1;
            return /*#__PURE__*/_jsxs("div", {
              className: classnames(styles.textPriceBlockV6, {}),
              children: [/*#__PURE__*/_jsx("div", {
                className: styles.textPriceBlockPriceV6,
                children: textPrices === null || textPrices === void 0 ? void 0 : textPrices.map(function (item, index) {
                  return /*#__PURE__*/_jsx("div", {
                    className: classnames(styles.textPriceWrapperV6, {
                      [styles.withStrikethough]: item.strikethrough
                    }),
                    children: item.text && item.price && /*#__PURE__*/_jsx("div", {
                      className: classnames(styles.textPrice, styles.textPriceV6),
                      children: item.text && item.price && /*#__PURE__*/_jsx("div", {
                        className: classnames(styles.textPriceV6First, {
                          [styles.withPlus]: hasPlus
                        }),
                        children: /*#__PURE__*/_jsx(TextPrice, {
                          text: item.text,
                          price: item.price,
                          ariaLabel: item.ariaLabel,
                          typog: 'headline4',
                          typogPriceText: 'bodycopy',
                          priceClass: classnames(item.priceClass, styles.priceTextV6),
                          className: classnames(item.className, styles.textV6)
                        })
                      })
                    })
                  }, "change-duration-price-".concat(index));
                })
              }), /*#__PURE__*/_jsx("div", {
                className: styles.textPriceBlockLabelV6,
                children: block.subLabel
              })]
            }, "change-duration-price-block-".concat(blockIdx));
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.contentV6),
          children: [textPrice === null || textPrice === void 0 ? void 0 : textPrice.map(function (item, index) {
            return /*#__PURE__*/_jsx(React.Fragment, {
              children: item.offer && /*#__PURE__*/_jsx("div", {
                className: styles.offerWrapperV6,
                children: /*#__PURE__*/_jsxs(Text, {
                  className: styles.offerV6,
                  typog: "bodycopy",
                  childrenInline: true,
                  children: [item.offer, renderTooltip()]
                })
              }, "change-duration-offer-".concat(index))
            }, "change-duration-offer-item-".concat(index));
          }), promoCopy && /*#__PURE__*/_jsx("div", {
            className: styles.promoCopy,
            children: Utility.dangerousHTML(promoCopy)
          })]
        })]
      }, "change-duration-desc-blocks-".concat(value));
    } else {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: classnames(styles.content, {
            [styles.contentV3]: version === 'V3' || version === 'V4',
            [styles.contentV4]: version === 'V4',
            [styles.contentV5]: version === 'V5'
          }),
          children: textPrice === null || textPrice === void 0 ? void 0 : textPrice.map(function (item, index) {
            return /*#__PURE__*/_jsxs("div", {
              className: version === 'V4' ? styles.textPriceWrapperV4 : styles.textPriceWrapper,
              children: [item.text && item.price && /*#__PURE__*/_jsxs("div", {
                className: classnames(styles.textPrice, version === 'V4' && styles.textPriceV4),
                children: [/*#__PURE__*/_jsx(TextPrice, {
                  text: item.text,
                  price: item.price,
                  typog: version === 'V4' ? 'headline4' : item.typog || 'subhead2',
                  typogPriceText: version === 'V4' ? 'bodycopyLarge' : item.typogPriceText || 'bodycopy',
                  priceClass: classnames(item.priceClass, {
                    [styles.strikethrough]: item.strikethrough,
                    [styles.priceTextV4]: version === 'V4'
                  }),
                  className: classnames(styles.text, item.className, version === 'V4' && styles.textV4)
                }), (tooltip === null || tooltip === void 0 ? void 0 : tooltip.position) === 'after_price' && index === textPrice.length - 1 && renderTooltip()]
              }), item.offer && /*#__PURE__*/_jsxs(Text, {
                className: classnames({
                  [styles.offer]: textPrice.length === 1,
                  [styles.offerV4]: version === 'V4'
                }),
                typog: "bodycopy",
                childrenInline: true,
                children: [item.offer, (tooltip === null || tooltip === void 0 ? void 0 : tooltip.position) === 'after_description' && (index === textPrice.length - 1 && version !== 'V4' || index === 0 && version === 'V4') && renderTooltip()]
              })]
            }, "change-duration-price-".concat(index));
          })
        }), addonToggle && /*#__PURE__*/_jsx("div", {
          className: styles.addonToggleContainer,
          children: /*#__PURE__*/_jsx(AddonToggle, _objectSpread({}, addonToggle))
        })]
      });
    }
  };
  var renderItem = function renderItem(mobileCarousel) {
    if (simplifiedCards) {
      return /*#__PURE__*/_jsx("div", {
        className: classnames(styles.item, {
          [styles.itemV6]: mobileCarousel
        }, wrapperClass),
        children: /*#__PURE__*/_jsx(RadioInput, {
          version: version,
          border: true,
          name: name,
          value: value,
          valueSelected: valueSelected,
          onChange: onItemChange,
          label: label,
          labelTypog: labelTypog || 'headline5',
          labelClass: styles.simplifiedCardLabel,
          flag: flag,
          flagTypog: 'bodycopy',
          flagWrapperClass: styles.flagWrapperV6,
          cta: cta,
          circleClass: styles.circleV6,
          wrapperClass: classnames(styles.radioInputWrapperV6),
          description: renderDescription(),
          mobileCarousel: mobileCarousel,
          simplifiedCards: simplifiedCards
        })
      });
    } else {
      return /*#__PURE__*/_jsx("div", {
        className: classnames(styles.item, wrapperClass),
        children: /*#__PURE__*/_jsx(RadioInput, {
          version: version,
          border: true,
          name: name,
          value: value,
          valueSelected: valueSelected,
          onChange: onItemChange,
          label: label,
          labelTypog: labelTypog || 'headline5',
          labelClass: version === 'V4' || version === 'V5' ? styles.labelV4 : styles.label,
          flag: flag,
          flagTypog: 'bodycopy',
          flagWrapperClass: styles.flagWrapper,
          cta: cta,
          circleClass: styles.circle,
          wrapperClass: classnames(styles.radioInputWrapper, {
            [styles.noClick]: version === 'V3',
            [styles.radioInputWrapperSelected]: value === valueSelected,
            [styles.radioInputWrapperV4]: version === 'V4' || version === 'V5',
            [styles.radioInputWrapperV5]: version === 'V5'
          }),
          description: mobileCarousel ? /*#__PURE__*/_jsx(MatchHeightElement, {
            group: "change-duration-description",
            children: renderDescription()
          }) : renderDescription(),
          descriptionHidden: priceBreakdown && /*#__PURE__*/_jsx(PriceBreakdown, {
            items: priceBreakdown.items,
            headline: priceBreakdown.headline,
            totalLabel: priceBreakdown.totalLabel,
            totalLabel2: priceBreakdown.totalLabel2,
            totalPrice: priceBreakdown.totalPrice,
            totalPrice2: priceBreakdown.totalPrice2,
            totalPriceAriaLabel: priceBreakdown.totalPriceAriaLabel,
            totalPrice2AriaLabel: priceBreakdown.totalPrice2AriaLabel,
            totalStrikethrough: priceBreakdown.totalStrikethrough,
            savingsLabel: priceBreakdown.savingsLabel,
            marketingMessage: priceBreakdown.marketingMessage,
            version: version
          }),
          mobileCarousel: mobileCarousel
        })
      });
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: mobileCarousel ? /*#__PURE__*/_jsx(MatchHeightElement, {
      group: "change-duration-item",
      children: renderItem(true)
    }) : renderItem(false)
  });
};